import * as React from "react";
import { AnatomicalSystemModel } from "../../../models/anatomicalSystem";
import AnatomicalSystemView from './anatomicalSystemView';
import AnatomicalSystemService from '../../../services/anatomicalSystemService';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import Loadable from 'react-loadable';
import AnatomicalSystemAddEditDialog from './anatomicalSystemAddEditDialog';
import { TreeNodeModel } from '../../../models/treeNodeModel';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import { ContextMenu } from 'primereact/contextmenu';
import { Lang } from '../../../common/enums';
import { AnatomicalSystemContentModel } from '../../../models/anatomicalSystem/anatomicalSystemContentModel';
import * as HelperFunctions from '../../../common/functions/helperFunctions';

/*const MedicineAddEditLoadable = Loadable({
	loader: () => import('./atcCodesAddEditDialog'),
	loading: Spinner,
	delay: 1000, // 0.1 seconds
	timeout: 10000, // 10 seconds
});*/

interface IProps {
}

interface IState {
  listAnatomicalSystems: Array<AnatomicalSystemModel>;
  treeAnatomicalSystems: Array<TreeNodeModel>;
  isLoading: boolean;
  error: any;
  validationMessage: string;
  isVisibleDialog: boolean;
  isVisibleConfirmDialog: boolean;
  currentAnatomicalSystem: AnatomicalSystemModel;
  selectionKeys: any;
  selectedAnatomicalSystemIds: Array<number>;
  contextMenu: any;
}

class AnatomicalSystemContainer extends React.Component<IProps, IState> {
  anatomicalSystemService = new AnatomicalSystemService();
  messages: any;
  growl: any;
  cm: any;

  constructor(props: IProps) {
    super(props);

    const menu = [
      // {
      //   label: 'Root',
      //   icon: 'pi pi-plus',
      //   command: () => { this.handleAddClick(null, 'root') }
      // },
      // {
      //   label: 'Sibling',
      //   icon: 'pi pi-plus',
      //   command: () => { this.handleAddClick(this.state.selectedAnatomicalSystemIds[0], 'sibling') }
      // },
      {
        label: 'Child',
        icon: 'pi pi-plus',
        command: () => { this.handleAddClick(this.state.selectedAnatomicalSystemIds[0], 'child') }
      },
      {
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => { this.handleEditClick(this.state.selectedAnatomicalSystemIds[0]) }
      },
      {
        label: 'Delete',
        icon: 'pi pi-trash',
        command: () => { this.handleDeleteClick() }
      }
    ];

    this.state = {
      error: null,
      validationMessage: '',
      listAnatomicalSystems: new Array<AnatomicalSystemModel>(0),
      treeAnatomicalSystems: new Array<TreeNodeModel>(0),
      isLoading: false,
      isVisibleDialog: false,
      isVisibleConfirmDialog: false,
      currentAnatomicalSystem: new AnatomicalSystemModel(),
      selectionKeys: null,
      selectedAnatomicalSystemIds: new Array<number>(0),
      contextMenu: menu
    };
  }

  // events
  componentDidMount() {
    this.getAllAnatomicSystems();
  }

  // handles
  handleAddClick = (parentId, type) => {
    var parent = this.state.listAnatomicalSystems.find(f => f.anatomicalSystemId == parentId);
    let parentLevelNo = parent ? parent.levelNo : 0;
    let parentParentID = parent ? parent.parentId : 0;
    let anatSys = new AnatomicalSystemModel();
    anatSys.parentId = type == 'sibling' ? parentParentID : parentId;
    anatSys.levelNo = (type == 'child' ? parentLevelNo + 1 : parentLevelNo);

    let contentList = new Array<AnatomicalSystemContentModel>(0);

    const langKeys = HelperFunctions.getEnumKeys(Lang);

    langKeys.map(k => {
      let content = new AnatomicalSystemContentModel();
      content.langId = parseInt(Lang[k]);
      content.anatomicalSystemName = '';
      contentList.push(content);
    });

    anatSys.anatomicalSystemContent = contentList;
    this.setcurrentAnatomicalSystem(anatSys);
    this.showEditDialog(true);
  };

  handleEditClick = id => {
    this.setState({
      isLoading: true
    });
    this.anatomicalSystemService.getAnatomicalSystem(id)
      .then(
        (data: AnatomicalSystemModel) => {
          this.setcurrentAnatomicalSystem(data);
          this.showEditDialog(true);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        }
      );
  };

  handleDeleteClick = () => {
    this.setState({
      isVisibleConfirmDialog: true
    });
  };

  deleteAtcCode(id: number) {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.anatomicalSystemService.deleteAnatomicalSystem(id)
      .then(
        data => {
          this.getAllAnatomicSystems();
          this.setState({
            isLoading: false,
            selectionKeys: null,
            selectedAnatomicalSystemIds: new Array<number>(0)
          });
          this.growl.show({ severity: 'success', detail: 'You have successfully deleted an Anatomical System.' });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleSelectionChange = (value) => {
    let atcCodeIds = new Array<number>(0);
    if (this.state.selectedAnatomicalSystemIds.some(v => v == value)) {
      value = null;
      atcCodeIds = new Array<number>(0);
    } else {
      atcCodeIds.push(+value);
    }
    //atcCodeIds = this.setSelectedATCCodesIds(Object.keys(value)); // for multiple selection
    this.setState({
      selectionKeys: value,
      selectedAnatomicalSystemIds: atcCodeIds.slice()
    });
  }

  // setSelectedATCCodesIds = (keys: Array<string>) => {
  //   let newArray = Array<number>(0);
  //   if (keys) {
  //     keys.map(key => {
  //       newArray.push(+key);
  //     });
  //   }
  //   return newArray;
  // }

  handleSaveButton = (currentAnatomicalSystem: AnatomicalSystemModel) => {
    this.setState({
      isLoading: true
    });

    if (!currentAnatomicalSystem.anatomicalSystemId) { // Add
      this.anatomicalSystemService.addAnatomicalSystem(currentAnatomicalSystem)
        .then(
          (data) => {
            this.showEditDialog(false);
            this.setcurrentAnatomicalSystem(new AnatomicalSystemModel());
            this.getAllAnatomicSystems();
            this.setState({
              isLoading: false
            });
            this.growl.show({ severity: 'success', detail: 'You have successfully created an Anatomical system.' });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentAnatomicalSystem(new AnatomicalSystemModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          }
        );
    } else { // Edit
      this.anatomicalSystemService.editAnatomicalSystem(currentAnatomicalSystem.anatomicalSystemId, currentAnatomicalSystem)
        .then(
          (data) => {
            this.showEditDialog(false);
            this.setcurrentAnatomicalSystem(new AnatomicalSystemModel());
            this.getAllAnatomicSystems();
            this.growl.show({ severity: 'success', detail: 'You have successfully updated an Anatomical system.' });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentAnatomicalSystem(new AnatomicalSystemModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          });
    }
  };

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  // methods
  getAllAnatomicSystems() {
    this.setState({
      isLoading: true
    });

    this.anatomicalSystemService.getAllAnatomicalSystems().then(
      (data: Array<AnatomicalSystemModel>) => {
        this.setState({
          listAnatomicalSystems: data
        });
        this.createTree();
        this.setState({
          isLoading: false
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  createTree() {
    let subTree = this.createSubTree(null);
    this.setState({
      treeAnatomicalSystems: subTree
    });
  }

  createSubTree(parentId) {
    let subTree = new Array<TreeNodeModel>(0);

    this.state.listAnatomicalSystems
      .filter(f => parentId ? f.parentId == parentId : f.parentId == null)
      .sort((a, b) => (a.orderNo > b.orderNo) ? 1 : (b.orderNo > a.orderNo ? -1 : 0))
      .map(f => {
        let node = new TreeNodeModel();
        node.key = f.anatomicalSystemId.toString();
        node.label = (f.anatomicalSystemContent && f.anatomicalSystemContent.length > 0 ? f.anatomicalSystemContent[0].anatomicalSystemName : '') +
          (f.anatomicalSystemContent[0].anatomicalSystemName && f.anatomicalSystemContent[1].anatomicalSystemName ? ' / ' : '') +
          (f.anatomicalSystemContent[1].anatomicalSystemName ? f.anatomicalSystemContent[1].anatomicalSystemName : '');
        node.data = { ...f };
        //node.icon = "pi pi-fw pi-circle-on";        
        if (this.state.listAnatomicalSystems.some(a => a.parentId == f.anatomicalSystemId)) {
          node.children = this.createSubTree(f.anatomicalSystemId);
        };
        subTree.push(node);
      });

    return subTree;
  }

  setcurrentAnatomicalSystem(activeIngredient: AnatomicalSystemModel) {
    this.setState({ currentAnatomicalSystem: { ...activeIngredient } });
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleDialog: show,
      validationMessage: ''
    });
  };

  getSelectedAtcCodeNames = () => {
    let atcCodes = new Array<string>(0);
    this.state.listAnatomicalSystems.filter(a => this.state.selectedAnatomicalSystemIds
      .some(b => b == a.anatomicalSystemId))
      .map(a => atcCodes.push(a.anatomicalSystemContent[0].anatomicalSystemName));
    return atcCodes.join(', ');
  }

  // render
  public render() {

    const { treeAnatomicalSystems, isLoading, error, selectionKeys, selectedAnatomicalSystemIds } = this.state;
    const atcNamesForDelete = this.getSelectedAtcCodeNames();

    return (
      <div>

        <h3>Anatomical systems</h3>

        {isLoading ? <Spinner /> : null}

        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

        <Growl ref={(el) => this.growl = el} />

        {this.state.isVisibleDialog ? (
          <AnatomicalSystemAddEditDialog
            saveClick={this.handleSaveButton}
            cancelClick={this.handleCancelButton}
            currentAnatomicalSystem={this.state.currentAnatomicalSystem}
            isVisible={this.state.isVisibleDialog}
          />
        ) : null}

        <div className="mb-2">
          <Button
            onClick={() => this.handleAddClick(null, 'root')}
            icon="pi pi-plus"
            className="p-button-success"
            style={{ marginRight: "5px" }}
            label="Root"
            tooltipOptions={{ position: 'top' }} />
          {/* <Button
            onClick={() => this.handleAddClick(selectedAnatomicalSystemIds[0], 'sibling')}
            icon="pi pi-plus"
            className="p-button-success"
            style={{ marginRight: "5px" }}
            label="Sibling"
            tooltipOptions={{ position: 'top' }}
            disabled={!(selectedAnatomicalSystemIds && selectedAnatomicalSystemIds.length == 1)}
          /> */}
          <Button
            onClick={() => this.handleAddClick(selectedAnatomicalSystemIds[0], 'child')}
            icon="pi pi-plus"
            className="p-button-success"
            style={{ marginRight: "5px" }}
            label="Child"
            tooltipOptions={{ position: 'top' }}
            disabled={!(selectedAnatomicalSystemIds && selectedAnatomicalSystemIds.length == 1)}
          />
          <Button
            onClick={() => this.handleEditClick(selectedAnatomicalSystemIds[0])}
            icon="pi pi-pencil"
            className="p-button-warning"
            style={{ marginRight: "5px" }}
            label="Edit"
            tooltipOptions={{ position: 'top' }}
            disabled={!(selectedAnatomicalSystemIds && selectedAnatomicalSystemIds.length == 1)}
          />
          <Button
            onClick={() => this.handleDeleteClick()}
            icon="pi pi-trash"
            className="p-button-danger"
            style={{ marginRight: "5px" }}
            label="Delete"
            tooltipOptions={{ position: 'top' }}
            disabled={!(selectedAnatomicalSystemIds && selectedAnatomicalSystemIds.length > 0)}
          />
        </div>

        <ContextMenu model={this.state.contextMenu} ref={el => this.cm = el} />

        <AnatomicalSystemView
          treeAnatomicalSystems={treeAnatomicalSystems}
          handleSelectionChange={this.handleSelectionChange}
          selectionKeys={selectionKeys}
          onContextMenu={event => (selectedAnatomicalSystemIds && selectedAnatomicalSystemIds.length > 0 ? this.cm.show(event.originalEvent) : null)}
        />

        <ConfirmDialog
          headerTitle="Confirm Dialog"
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteAtcCode(this.state.selectedAnatomicalSystemIds[0]) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          Are you sure that you want to delete "{atcNamesForDelete}" and all its children?
        </ConfirmDialog>
      </div>
    );
  }
}

export default AnatomicalSystemContainer;